// modules


//style
import '../style/main.scss';

// SVG sprite
import './modules/svgSprite';


//libs
import { Modal } from 'bootstrap';

window.addEventListener('load', function () {

    const header = document.querySelector('.jsHeader');

    if (header) {
        window.addEventListener('scroll', function (e) {
             window.scrollY ? header.classList.add('is-stuck') : header.classList.remove('is-stuck')
        })
    }

    const menuTriggers = document.querySelectorAll('.jsMenuTrigger');

    if (menuTriggers.length) {
        menuTriggers.forEach(trigger => {
            trigger.addEventListener('click', function () {
                document.querySelector('.jsMenu').classList.toggle('is-active');
                document.querySelector('html').classList.toggle('is-fixed');
            })
        })
    }

    const scrollButtons = document.querySelectorAll('.jsScrollButton');

    if (scrollButtons.length) {
        scrollButtons.forEach(btn => {
            btn.addEventListener('click', function (e){
                e.preventDefault();
                const target = document.querySelector(`${btn.getAttribute('href')}`);
                if (target) {
                    const position = target.getBoundingClientRect().top + window.pageYOffset;
                    window.scroll({
                        top: position - header.getBoundingClientRect().height,
                        left: 0,
                        behavior:'smooth',
                    });
                }


                if (window.innerWidth < 1024) {
                    document.querySelector('.jsMenu').classList.toggle('is-active');
                    document.querySelector('html').classList.toggle('is-fixed');
                }
            })
        })
    }

    const copyBtns = document.querySelectorAll('.jsCopyBtn');

    function copyToClipboard(text) {
        const el = document.createElement('textarea');
        el.value = text;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }

    if (copyBtns.length) {
        copyBtns.forEach(btn => {
            btn.addEventListener('click', function () {
                copyToClipboard(this.dataset.text);

                document.querySelectorAll('.jsTooltip').forEach(tooltip => {
                    if (tooltip.classList.contains('is-active')) {
                        tooltip.classList.remove('is-active')
                    }
                })

                const tooltip = this.closest('.link-block').querySelector('.jsTooltip')
                tooltip.classList.add('is-active')

                setTimeout(function (){
                    tooltip.classList.remove('is-active');
                },3000)
            })
        })
    }
})
